define(['text!./templates/payment-date.html'],
    (templateStr)=> {
        return [()=> {
            return {
                restrict: 'A',
                scope: {
                    policyEffectiveDate: '=policyEffectiveDate',
                    valueSelected: '=valueSelected'

                },
                template: templateStr,
                controller: ['$scope',(scope)=> {
                    var dateMap = new Map();
                    dateMap.set("1",["1","2","3","4","5","6"]);
                    dateMap.set("2",["2","3","4","5","6","7"]);
                    dateMap.set("3",["3","4","5","6","7","8"]);
                    dateMap.set("4",["4","5","6","7","8","9"]);
                    dateMap.set("5",["5","6","7","8","9","10"]);
                    dateMap.set("6",["6","7","8","9","10","11"]);
                    dateMap.set("7",["7","8","9","10","11","12"]);
                    dateMap.set("8",["8","9","10","11","12","13"]);
                    dateMap.set("9",["9","10","11","12","13","14"]);
                    dateMap.set("10",["10","11","12","13","14","15"]);
                    dateMap.set("11",["11","12","13","14","15","16"]);
                    dateMap.set("12",["12","13","14","15","16","17"]);
                    dateMap.set("13",["13","14","15","16","17","18"]);
                    dateMap.set("14",["14","15","16","17","18","19"]);
                    dateMap.set("15",["15","16","17","18","19","20"]);
                    dateMap.set("16",["16","17","18","19","20","21"]);
                    dateMap.set("17",["17","18","19","20","21","22"]);
                    dateMap.set("18",["18","19","20","21","22","23"]);
                    dateMap.set("19",["19","20","21","22","23","24"]);
                    dateMap.set("20",["20","21","22","23","24","25"]);
                    dateMap.set("21",["21","22","23","24","25","26"]);
                    dateMap.set("22",["22","23","24","25","26","27"]);
                    dateMap.set("23",["23","24","25","26","27","28"]);
                    dateMap.set("24",["24","25","26","27","28"]);
                    dateMap.set("25",["25","26","27","28"]);
                    dateMap.set("26",["26","27","28"]);
                    dateMap.set("27",["27","28"]);
                    dateMap.set("28",["28"]);
                    dateMap.set("29",["29"]);
                    dateMap.set("30",["30"]);
                    dateMap.set("31",["31"]);
                    scope.selectDateList = dateMap.get(scope.policyEffectiveDate.toString());

                }]
            };
        }];
    });


/** WEBPACK FOOTER **
 ** ./app/customer/js/src/edge/policyjob/directives/PaymentDateSelector.js
 **/